import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import EventIcon from '@mui/icons-material/Event';
import CircularProgress from '@mui/material/CircularProgress';

function ScheduledServicesIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null); // Track the item ID to delete
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        fetchtableData();
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchtableData();
    }, []);

    // const fetchtableData = async () => {

    //     fetchData('ScheduleServiceApi', `/${companyId}`, token)
    //         .then((response) => {
    //             if (response.responseCode == '1111') {
    //                 console.log(response);
    //                 setData(response.response_data);

    //             }
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching Request Details:', error);
    //         });

    // };
    const fetchtableData = async () => {
        setLoading(true);
        try {
            const response = await fetchData('ScheduleServiceApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                console.log(response);
                setData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
        } finally {
            setLoading(false); // Hide loading screen
        }
    };

    const handleDelete = async () => {
        deleteData('ScheduleServiceApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData(); // Refresh data after deletion
                setDeleteItemId(null); // Reset the item ID
                setConfirmDialogOpen(false); // Close the dialog
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('ScheduleServiceApi', `${itemId}`, token)
            .then((response) => {
                fetchtableData(); // Refresh data after deletion
            })
            .catch((error) => {
                // Handle errors for the activation request
            });
    };


    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const handleRequest = (id) => {
        console.log(`Request action clicked for item with id ${id}`);
    };
    const [modalOpen, setModalOpen] = useState(false);
    const openModal = () => {
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    const [selectedStaff, setSelectedStaff] = useState('');
    const [staffOptions, setStaffOptions] = useState([]);

    const fetchStaff = async () => {
        try {
            const response = await fetchData('StaffApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                setStaffOptions(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Work Types:', error);
        }
    };

    useEffect(() => {
        fetchStaff();
    }, []);

    const [selectedRequestId, setSelectedRequestId] = useState(null); // Track the selected request for allocation
    const [allocateModalOpen, setAllocateModalOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedStaffIds, setSelectedStaffIds] = useState([]);
    const handleRequestAllocation = (id) => {
        setSelectedRequestId(id);
        setAllocateModalOpen(true);
    };

    const closeAllocateModal = () => {
        setSelectedRequestId(null);
        setSelectedDate('');
        setSelectedStaffIds([]);
        setAllocateModalOpen(false);
    };

    const handleAllocateSave = () => {
        // Here you can handle saving the allocation details
        // You can use selectedRequestId, selectedDate, and selectedStaffIds
        console.log("Request ID:", selectedRequestId);
        console.log("Selected Date:", selectedDate);
        console.log("Selected Staff IDs:", selectedStaffIds);
        closeAllocateModal();
    };

    return (
        // <div className="w-full max-w-sm container mt-6 mx-auto" style={{ overflow: 'auto' }}>
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ overflowY: 'auto', maxWidth: '100%' }}>
            <div className='w-full mb-2 flex'>
                <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>SCHEDULED SERVICES</h6>
                {
                    loading && (
                        <div style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 9999
                        }}>
                            <div>
                                <CircularProgress style={{ color: 'white' }} />
                                <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                            </div>
                        </div>
                    )
                }
                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                    <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                    {showSearchInput && (
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            style={{ marginLeft: '10px', width: '200px' }}
                        />
                    )}
                </div>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '510px', overflowY: 'auto', marginTop: '-1%' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#090040' }}> {/* Set background color */}
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', width: '20px', color: 'white', textTransform: 'uppercase' }}>Sl.No</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Name</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Contact No</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Address</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Warranty</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Remarks</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Product</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Eng.Name</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>W.status</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Reschedule</TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: '#D5F5E3' }}>
                            {/* {data.map(item => ( */}
                            {filteredData.map((item, index) => (
                                // <TableRow key={item.Id} >
                                <TableRow
                                    key={item.Id}
                                    style={{ backgroundColor: item.isPriority ? '#F8EDED' : 'inherit' }}
                                >
                                    <TableCell sx={{ fontSize: '13px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center', width: '20px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ fontSize: '13px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center' }}>
                                        {item.createdDate && new Date(item.createdDate).toLocaleDateString('en-GB')}
                                    </TableCell>
                                    {/* <TableCell sx={{ fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center' }}>{item.customer} - ({item.customertype})
                                        
                                    </TableCell > */}
                                    <TableCell sx={{ fontSize: '13px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'left', width: '10%' }}>{item.customer} </TableCell >
                                    <TableCell sx={{ fontSize: '13px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'left' }}>{item.number}</TableCell>
                                    <TableCell sx={{ fontSize: '13px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'left', width: '30%' }}> {item.address} ,{item.landmark}
                                        {item.pincode}</TableCell>
                                    {/* {item.contactperson}, */}
                                    <TableCell sx={{ fontSize: '13px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'left' }}>{item.warranty}</TableCell>
                                    <TableCell sx={{ fontSize: '13px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'left', width: '30%' }}>{item.remarks}</TableCell>


                                    <TableCell sx={{ fontSize: '13px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'left' }}>{item.serviceRequestTypes}-{item.product}/({item.modal})</TableCell>

                                    {/* <p>({item.modal})</p></TableCell> */}
                                    <TableCell sx={{ fontSize: '13px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'left', width: '15%' }}>{item.engineerName}</TableCell>
                                    <TableCell sx={{ fontSize: '13px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'left', width: '5%' }}>{item.engineerWorkSS}</TableCell>
                                    <TableCell sx={{ fontSize: '13px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'left', width: '10%' }}>

                                        <Link to={`/Reschedulerequest/${item.requestID}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                            <IconButton>
                                                <EventIcon style={{ color: '#CF6543', fontWeight: 'bold' }} />
                                                <span style={{ color: '#CF6543', fontWeight: 'bold', fontSize: '12px' }}>Reschedule</span>
                                            </IconButton>
                                            {/* <span style={{ color: '#CF6543', fontWeight: 'bold' }}>Reschedule</span> */}
                                        </Link>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>

                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}

export default ScheduledServicesIndex;

